import DashboardTaskSummary from '../components/Dashboard/DashboardTaskSummary';
import DashboardUserAssignedTasks from '../components/Dashboard/DashboardUserAssignedTasks';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import React from 'react';
import DashboardRiskLevel from '../components/Dashboard/DashboardRiskLevel';

export function getDefaultDashboardWidgetSettings(componentType) {
    switch (componentType) {
        case 'DashboardTaskSummary':
            return {
                dateRangeEnabled: false,
                dateRange: {
                    start: '',
                    end: ''
                }
            };
        case 'DashboardUserAssignedTasks':
            return { excludedStatusIds: [9] };
        default:
            return {};
    }
}

export function getDefaultDashboardWidgetJsonSettings(componentType) {
    return JSON.stringify(getDefaultDashboardWidgetSettings(componentType));
}

export function getDashboardWidgetComponent(componentType, jsonSettings, onSettingsChange) {
    switch (componentType) {
        case 'DashboardTaskSummary':
            return <DashboardTaskSummary jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardUserAssignedTasks':
            return <DashboardUserAssignedTasks jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardRiskLevel':
            return <DashboardRiskLevel jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        default:
            return <AddCircleOutlineIcon style={{ fontSize: 80 }} />;
    }
}

export function getBaseDashboardComponents() {
    return [
        { id: 'box1', position: 0 },
        { id: 'box2', position: 1 },
        { id: 'box3', position: 2 },
        { id: 'box4', position: 3 },
    ];
}

export function getDefaultDashboardWidgets() {
    return [
        {
            id: 'box1',
            position: 0,
            component: 'DashboardTaskSummary',
            name: 'DashboardTaskSummary',
            jsonSettings: getDefaultDashboardWidgetJsonSettings('DashboardTaskSummary')
        },
        {
            id: 'box2',
            position: 1,
            component: 'DashboardUserAssignedTasks',
            name: 'DashboardUserAssignedTasks',
            jsonSettings: getDefaultDashboardWidgetJsonSettings('DashboardUserAssignedTasks')
        },
    ];
}
